"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.JSON_CONTENT = void 0;
var JSON_CONTENT = exports.JSON_CONTENT = 'application/json'; //# sourceMappingURL=contentTypes.js.map
